// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../../../sidebars/ConfirmationModal.bs.js";

function CloseCreateModificationConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Unsaved Changes",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Exit",
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, "You are about to leave this page. All the changes will be lost. Are you sure you want to exit?")
            });
}

var make = CloseCreateModificationConfirmationModal;

export {
  make ,
  
}
/* react Not a pure module */
